import React from 'react';
import Icon from '../Icon/Icon.jsx';
// Styles
import './Location.css';

const NAME = 'location';
const Location = ({
    description
}) => {
    return (
        <div className={`${NAME}-container`}>
            <Icon name="pin" value="location" color="#cf4500" size={10} className="io-input-icon" />
            <span className={`${NAME}-text`}>{description}</span>
        </div>
    );
}

export default Location;
